import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WtProgressModule } from './wt-progress/wt-progress.module';
import { BrowserModule } from '@angular/platform-browser';
import { MoodcheckModule } from './moodcheck-modal/moodcheck.module';
import { TutorialPage } from './tutorial/tutorial';
import { AssessmentResilienceAlert } from './assessment-resilience-alert/assessment-resilience-alert';
import { Invite } from './invite/invite';
import { ResilienceListingComponent } from './resilience-listing/resilience-listing.component';
import { HistoryPage } from './moodcheck-history/moodcheck-history';
import { DatePickerModule } from './ng2-datepicker/ng2-datepicker.module';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { AnswerComponent } from './answer-modal/answer-modal.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ActivityModal } from './activity-modal/activity-modal.component';
import { ActivityPopup } from './activity-popup/activity-popup.component';
import { DashboardAdminComponent } from './dashboards/dashboard-admin/dashboard-admin.component';
import { UserEditComponent } from './admin/user-edit/user-edit.component';
import { UserCreateComponent } from './admin/user-create/user-create.component';

import { CreateDemoUser } from './admin/create-demo-user/create-demo-user.component';
import { OrgAuthComponent } from './admin/org-auth/org-auth.component';
import { OrganizationAdminEditComponent } from './admin/organization-admin-edit/organization-admin-edit.component';
import { AccessCodeComponent } from './admin/access-code/access-code.component';
import { ActivityListingComponent } from './activity-listing/activity-listing.component';
import { LineChartComponent } from './graphs/linechart/linechart.component';
import { DonutChartComponent } from './graphs/donutchart/donutchart.component';
import { GeneralModalComponent } from './misc/generalmodal/generalmodal.component';
import { SchedulerModalModule } from 'app/components/scheduler-modal/scheduler-modal.module';
import { RegisterComponent } from './register/register';
import { MessagingListingComponent } from './messaging/messaging-listing/messaging-listing';
import { MessagingThreadComponent } from './messaging/messaging-thread/messaging-thread';
import { MessageComponent } from './messaging/message/message.component';
import { ResourcesComponent } from '../components/resources/resources.component';
import { DemographicResilienceComponent } from './demographic-resilience/demographic-resilience';
import { CourseFeedbackComponent } from '../components/course-feedback/course-feedback.component';
import { CourseVideoCardComponent } from '../components/course-video-card/course-video-card.component';
import { PopupLoader } from '../components/popup-loader/popup-loader.component';
import { SharedModule } from '../shared/shared.module';

import { CalendarModule } from 'angular-calendar';
import { CalendarComponent } from '../components/calendar/calendar.component';
import { CalendarProfessionalComponent } from '../components/calendar/calendar-professional/calendar-professional.component';
import { GraphChartsComponent } from './graph-charts/graph-charts.component';

import { NoticeComponent } from './notice/notice-component';
import { CounselorUserAssociations } from './admin/counselor-user-associations/counselor-user-associations';
import { CreateAssociation } from './admin/create-association/create-association';

import { ActivitySchedulingComponent } from './calendar/activity-scheduling/activity-scheduling.component';
import { UserSelectionSingleComponent } from './calendar/user-selection-single/user-selection-single.component';
import { EventListingComponent } from './calendar/event-listing/event-listing.component';
import { SupportComponent } from './support/support';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgxPaginationModule } from 'ngx-pagination';
import { TabsModule } from './tabs/tabs.module';
import { MatTableModule } from '@angular/material/table';
import { OrganizationCloneComponent } from './admin/organization-clone/organization-clone.component';
import { CourseCompleteFeedbackComponent } from './course-complete-feedback/course-complete-feedback.component';

import { AssessmentEditComponent } from './admin/assessments-edit/assessments-edit.component';
import { CourseAdminEditComponent } from './admin/course-admin-edit/course-admin-edit.component';
import { ScheduledPushEditComponent } from './scheduled-push-edit/scheduled-push-edit.component';
import { AdditionalResourceEditComponent } from './admin/additional-resource-edit/additional-resource-edit.component';
import { ResourceTableViewComponent } from './resource-table-view/resource-table-view.component';
import { ResourcesEditComponent } from './resources-edit-component/resources-edit-component';
import { ResourcesEditModal } from './resources-edit-modal/resources-edit-modal.component';
import { MultiselectAutocomplete } from './multi-select-autocomplete/multi-select-autocomplete.component';
import { DemographicEditComponent } from './demographic-edit/demographic-edit.component';
import { TagsAutocomplete } from './tags-autocomplete/tags-autocomplete';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MenuModule } from '../modules/menu/menu.module';
import { AddResourcesComponent } from './admin/add-resources/add-resources.component';
import { FavouriteListingComponent } from './favourite-listing/favourite-listing.component';
import { ConfigListingComponent } from './config-listing/config-listing.component';
import { CreateConfigComponent } from './create-config/create-config.component';

import { LegendComponent } from './calendar/legend/legend.component';
import { AuditListingComponent } from './audit-listing/audit-listing.component';
import { ViewPrevalueAuditComponent } from './view-prevalue-audit/view-prevalue-audit.component';
import { AlertsListingComponent } from './alerts-listing/alerts-listing.component';
import { ConsentModalComponent } from './consent-modal/consent-modal.component';
import { NpsSurveyComponent } from './nps-survey/nps-survey.component';
import { NumberScaleComponent } from './number-scale/number-scale.component';
import { NpsSurveyListingComponent } from './nps-survey-listing/nps-survey-listing.component';
import { SystemPermissionComponent } from './system-permission/system-permission.component';
import { CreatePermissionComponent } from './create-permission/create-permission.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { NpsSurveyModalComponent } from './nps-survey-modal/nps-survey-modal.component';
import { ShareModalComponent } from './share-modal/share-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UserOnboardingComponent } from './user-onboarding/user-onboarding.component';
import { ConsentPageComponent } from './consent-page/consent-page.component';
import { OrganizationAssociateComponent } from 'app/pages/organization-associate/organization-associate.component';
import { MoodcheckRemindersComponent } from './moodcheck-reminders/moodcheck-reminders.component';
import { InviteProfessionalsComponent } from './invite-professionals/invite-professionals.component';
import { InviteProfessional } from './invite-professional/invite-professional.component';
import { CourseAdminAudioEditComponent } from './admin/course-admin-audio-edit/course-admin-audio-edit.component';
import { CourseBurningQuestionEditComponent } from './admin/course-burning-question-edit/course-burning-question-edit.component';
import { DailySeriesCreateComponent } from './admin/daily-series-create/daily-series-create.component';
import { DailySeriesAddComponent } from './admin/daily-series-add/daily-series-add.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import {
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { EmergencyCallMsgModalComponent } from './emergency-call-msg-modal/emergency-call-msg-modal.component';
import { CourseAdminReadsEditComponent } from './course-admin-reads-edit/course-admin-reads-edit.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [
        TutorialPage,
        Invite,
        ResilienceListingComponent,
        HistoryPage,
        AssessmentResilienceAlert,
        AudioPlayerComponent,
        VideoPlayerComponent,
        AnswerComponent,
        ActivityModal,
        ActivityPopup,
        DashboardAdminComponent,
        UserEditComponent,
        UserCreateComponent,

        CreateDemoUser,
        OrganizationAdminEditComponent,
        AccessCodeComponent,
        ActivityListingComponent,
        LineChartComponent,
        DonutChartComponent,
        GeneralModalComponent,
        ResourcesComponent,
        RegisterComponent,
        MessagingListingComponent,
        MessagingThreadComponent,
        MessageComponent,
        DemographicResilienceComponent,
        CourseFeedbackComponent,
        CalendarComponent,
        CalendarProfessionalComponent,
        GraphChartsComponent,
        NoticeComponent,
        CounselorUserAssociations,
        CreateAssociation,
        ActivitySchedulingComponent,
        UserSelectionSingleComponent,
        EventListingComponent,
        OrgAuthComponent,
        SupportComponent,
        OrganizationCloneComponent,
        AssessmentEditComponent,
        CourseCompleteFeedbackComponent,
        CourseAdminEditComponent,
        ScheduledPushEditComponent,
        CourseVideoCardComponent,
        PopupLoader,
        AdditionalResourceEditComponent,
        ResourceTableViewComponent,
        ResourcesEditComponent,
        ResourcesEditModal,
        MultiselectAutocomplete,
        DemographicEditComponent,
        AddResourcesComponent,
        FavouriteListingComponent,
        TagsAutocomplete,
        FavouriteListingComponent,
        ConfigListingComponent,
        CreateConfigComponent,
        LegendComponent,
        AuditListingComponent,
        ViewPrevalueAuditComponent,
        AlertsListingComponent,
        ConsentModalComponent,
        NpsSurveyComponent,
        NumberScaleComponent,
        NpsSurveyListingComponent,
        AuditListingComponent,
        ViewPrevalueAuditComponent,
        SystemPermissionComponent,
        CreatePermissionComponent,
        ConfigListingComponent,
        DynamicFormComponent,
        NpsSurveyModalComponent,
        ShareModalComponent,
        InviteProfessionalsComponent,
        UserOnboardingComponent,
        ConsentPageComponent,
        OrganizationAssociateComponent,
        MoodcheckRemindersComponent,
        InviteProfessional,
        CourseAdminAudioEditComponent,
        CourseBurningQuestionEditComponent,
        DailySeriesCreateComponent,
        DailySeriesAddComponent,
        EmergencyCallMsgModalComponent,
        CourseAdminReadsEditComponent,
    ],
    exports: [
        TutorialPage,
        HistoryPage,
        Invite,
        ResilienceListingComponent,
        AssessmentResilienceAlert,
        AudioPlayerComponent,
        VideoPlayerComponent,
        DashboardAdminComponent,
        ActivityListingComponent,
        UserEditComponent,
        UserCreateComponent,

        CreateDemoUser,
        LineChartComponent,
        DonutChartComponent,
        GeneralModalComponent,
        ResourcesComponent,
        RegisterComponent,
        MessagingListingComponent,
        MessagingThreadComponent,
        MessageComponent,
        DemographicResilienceComponent,
        CourseFeedbackComponent,
        CalendarComponent,
        CalendarProfessionalComponent,
        GraphChartsComponent,
        NoticeComponent,
        CounselorUserAssociations,
        CreateAssociation,
        ActivitySchedulingComponent,
        UserSelectionSingleComponent,
        EventListingComponent,
        SupportComponent,
        TabsModule,
        CourseCompleteFeedbackComponent,
        ScheduledPushEditComponent,
        CourseVideoCardComponent,
        PopupLoader,
        AdditionalResourceEditComponent,
        ResourceTableViewComponent,
        ResourcesEditComponent,
        MultiselectAutocomplete,
        DemographicEditComponent,
        AddResourcesComponent,
        TagsAutocomplete,
        LegendComponent,
        NumberScaleComponent,
    ], imports: [BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        WtProgressModule,
        MoodcheckModule,
        TabsModule,
        DatePickerModule,
        NgxPaginationModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        CKEditorModule,
        SchedulerModalModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatRippleModule,
        MatSelectModule,
        MatSliderModule,
        MatSnackBarModule,
        MatTableModule,
        CalendarModule,
        CarouselModule,
        DragDropModule,
        MenuModule,
        SharedModule,
        MatFormFieldModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class WtComponentModule {}
